/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tld_Pricing_Column_Auto_RegistrationInputs */

const id_tld_pricing_column_auto_registration = /** @type {(inputs: Tld_Pricing_Column_Auto_RegistrationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrasi otomatis`)
};

const en_tld_pricing_column_auto_registration = /** @type {(inputs: Tld_Pricing_Column_Auto_RegistrationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto registration`)
};

/**
* | output |
* | --- |
* | "Auto registration" |
*
* @param {Tld_Pricing_Column_Auto_RegistrationInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const tld_pricing_column_auto_registration = /** @type {((inputs?: Tld_Pricing_Column_Auto_RegistrationInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tld_Pricing_Column_Auto_RegistrationInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tld_pricing_column_auto_registration(inputs)
	return id_tld_pricing_column_auto_registration(inputs)
});